<template>
  <div id="app">
    <!-- <div class="nav">
      <div class="nav-header">
        <div class="nav-title">
          DCC6
        </div>
      </div>
      <div class="nav-btn">
        <label for="nav-check">
          <span></span>
          <span></span>
          <span></span>
        </label>
      </div>
      <input type="checkbox" id="nav-check">
      <div class="nav-links">
        <a href="#about">ค่ายอะไร</a>
        <a href="#timelines">ตารางเวลา</a>
        <a href="#contact">ติดต่อสอบถาม</a>
        <a href="#branchs">สมัคร</a>
      </div>
    </div> -->
    <router-view/>
  </div>
</template>

<script>
export default {
  name: "App"
};
</script>

<style>
body {
  margin: 0;
}

#app {
  font-family: "Kanit", "Avenir", Helvetica, Arial, sans-serif;
}

td,th {
  white-space: nowrap;
}

/* .nav {
  height: 50px;
  width: 100%;
  background-color: #fff;
  position: fixed;
  z-index: 999;
}

.nav > .nav-header {
  display: inline;
}

.nav > .nav-header > .nav-title {
  display: inline-block;
  font-size: 22px;
  color: #310e34;
  padding: 10px 10px 10px 10px;
}

.nav > .nav-btn {
  display: none;
}

.nav > .nav-links {
  display: inline;
  float: right;
  font-size: 18px;
}

.nav > .nav-links > a {
  display: inline-block;
  padding: 13px 10px 13px 10px;
  text-decoration: none;
  color: #310e34;
}

.nav > .nav-links > a:hover {
  background-color: #8e1625;
  color: #fff;
}

.nav > #nav-check {
  display: none;
}

@media (max-width:600px) {
  .nav > .nav-btn {
    display: inline-block;
    position: absolute;
    right: 0px;
    top: 0px;
  }
  .nav > .nav-btn > label {
    display: inline-block;
    width: 50px;
    height: 50px;
    padding: 13px;
  }
  .nav > .nav-btn > label:hover {
    background-color: #8e1625;
  }
  .nav > .nav-btn > label > span {
    display: block;
    width: 25px;
    height: 10px;
    border-top: 2px solid #310e34;
  }
  .nav > .nav-links {
    position: absolute;
    display: block;
    width: 100%;
    background-color: #fff;
    height: 0px;
    transition: all 0.3s ease-in;
    overflow-y: hidden;
    top: 50px;
    left: 0px;
    text-align: center;
  }
  .nav > .nav-links > a {
    display: block;
    width: 100%;
  }
  .nav > #nav-check:not(:checked) + .nav-links {
    height: 0px;
  }
  .nav > #nav-check:checked + .nav-links {
    height: calc(100vh - 50px);
    overflow-y: auto;
  }
} */
</style>



// WEBPACK FOOTER //
// src/App.vue